/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
} from './InsurancePayor';
import type { PalAuthIntegrationCredentialsType } from './PalAuthIntegrationCredentialsType';
import {
    PalAuthIntegrationCredentialsTypeFromJSON,
    PalAuthIntegrationCredentialsTypeFromJSONTyped,
    PalAuthIntegrationCredentialsTypeToJSON,
} from './PalAuthIntegrationCredentialsType';
import type { PalAuthPlatform } from './PalAuthPlatform';
import {
    PalAuthPlatformFromJSON,
    PalAuthPlatformFromJSONTyped,
    PalAuthPlatformToJSON,
} from './PalAuthPlatform';

/**
 * 
 * @export
 * @interface PalAuthIntegration
 */
export interface PalAuthIntegration {
    /**
     * 
     * @type {string}
     * @memberof PalAuthIntegration
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthIntegration
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthIntegration
     */
    payor_id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthIntegration
     */
    auth_platform_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PalAuthIntegration
     */
    enabled: boolean;
    /**
     * 
     * @type {PalAuthIntegrationCredentialsType}
     * @memberof PalAuthIntegration
     */
    credentials_type: PalAuthIntegrationCredentialsType;
    /**
     * 
     * @type {InsurancePayor}
     * @memberof PalAuthIntegration
     */
    payor?: InsurancePayor;
    /**
     * 
     * @type {PalAuthPlatform}
     * @memberof PalAuthIntegration
     */
    auth_platform?: PalAuthPlatform;
}

/**
 * Check if a given object implements the PalAuthIntegration interface.
 */
export function instanceOfPalAuthIntegration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "payor_id" in value;
    isInstance = isInstance && "auth_platform_id" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "credentials_type" in value;

    return isInstance;
}

export function PalAuthIntegrationFromJSON(json: any): PalAuthIntegration {
    return PalAuthIntegrationFromJSONTyped(json, false);
}

export function PalAuthIntegrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthIntegration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'],
        'payor_id': json['payor_id'],
        'auth_platform_id': json['auth_platform_id'],
        'enabled': json['enabled'],
        'credentials_type': PalAuthIntegrationCredentialsTypeFromJSON(json['credentials_type']),
        'payor': !exists(json, 'payor') ? undefined : InsurancePayorFromJSON(json['payor']),
        'auth_platform': !exists(json, 'auth_platform') ? undefined : PalAuthPlatformFromJSON(json['auth_platform']),
    };
}

export function PalAuthIntegrationToJSON(value?: PalAuthIntegration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'payor_id': value.payor_id,
        'auth_platform_id': value.auth_platform_id,
        'enabled': value.enabled,
        'credentials_type': PalAuthIntegrationCredentialsTypeToJSON(value.credentials_type),
        'payor': InsurancePayorToJSON(value.payor),
        'auth_platform': PalAuthPlatformToJSON(value.auth_platform),
    };
}

